import { getRequest, postRequest } from './request'

export function createProject(projectForm) {
  return postRequest('/project/create', projectForm)
}
export function projectEdit(projectForm) { //编辑项目
  return postRequest('project/edit', projectForm)
}
export function otaEdit(projectForm) { //编辑ota
  return postRequest('ota/edit', projectForm)
}
export function deleteProject(projectId) {
  return postRequest('/project/delete', { 'id': projectId })
}

//获取项目列表
export function getProjectList(page, size, deviceName) {
  return getRequest('/project/list', {
    deviceName,
    'page': page,
    'size': 100
  })
}
//查看ota列表
export function getOtaProjects(page, size) {
  return getRequest('ota/projects', {
    'page': page,
    'size': 100
  })
}